module.exports = __webpack_public_path__ + "img/holidays-public.68d4dd7c.svg";